import { Input } from '@builder.io/sdk';

import { ButtonVariant } from '@/react/components/core-ui/Button/IBaseButtonProps';

export const buttonVariant = {
  name: 'variant',
  type: 'text',
  defaultValue: 'primary',
  enum: [
    'primary',
    'secondary',
    'tertiary',
    'tertiary-light',
    'text',
    'link',
    'danger',
    'decorative-link',
    'transparent-dark',
    'transparent-light',
    'outline-light'
  ] as Array<ButtonVariant>
} satisfies Input;
